import {
  SEARCH_ALERTS_API,
  SEARCH_DISMISS_DEVICE_VALUE_CONFLICT_API,
  SEARCH_DISMISS_UNKNOWN_DEVICE_REGISTRATION_API
} from '~/constants/APIs/alerts'
import axiosClient from './axiosClient'
import { AlertSearchResults } from '~/models'

export const alertsApis = {
  getCurrent: () => axiosClient.get(SEARCH_ALERTS_API) as unknown as AlertSearchResults,

  dismissDeviceValuesConflict: (deviceId: string) =>
    axiosClient.post(SEARCH_DISMISS_DEVICE_VALUE_CONFLICT_API + deviceId),

  dismissUnknownDeviceRegistrationAlert: (alertId: number) =>
    axiosClient.post(SEARCH_DISMISS_UNKNOWN_DEVICE_REGISTRATION_API + alertId, {
      headers: { 'Content-Type': 'application/json' }
    })
}
